import {ICharTalent} from "../../_interfaces/ICharTalent";
import {v4} from "uuid";
import {DisciplinesSubscriber, TalentSkillSubscriber} from "../../_helper/DataBehaves";

const DisziplineTalents = {
    getTalente: function (cid: string, disziplin: string, playercircle: number) {
        let talente: ICharTalent[] = [];
        const dt = DisciplinesSubscriber.value;
        const data_talente_skills = TalentSkillSubscriber.value

        dt.forEach((d) => {
            if (d.name === disziplin) {
                d.TuF[playercircle].talente.forEach((t) => {
                    for (let j = 0; j < data_talente_skills.length; j++) {
                        let test = t.replace(/(.*) \[.*\]/, "$1")
                        if (test === data_talente_skills[j].name) {
                            const fTalent = data_talente_skills[j];
                            let lpstart = DisziplineTalents.lpGetStart(playercircle);

                            let talent: ICharTalent = {
                                id: v4(),
                                cid: cid,
                                name: fTalent.name,
                                discipline: disziplin,
                                circle: playercircle,
                                descr: 'Frei ' + playercircle + ' ',
                                optional: false,
                                karma: true,
                                free: false,
                                lpstart: lpstart,
                                step: 0,
                                stepfree: 0,
                                strain: fTalent.strain,
                                attribute: fTalent.attribute,
                                action: fTalent.action,
                                define:[]
                            }
                            talente.push(talent);
                        }
                    }
                });

                if (d.TuF[playercircle].hasOwnProperty('free')) {
                    d.TuF[playercircle].free.forEach((t) => {
                        for (let j = 0; j < data_talente_skills.length; j++) {
                            let test = t.replace(/(.*) \[.*\]/, "$1")
                            if (test === data_talente_skills[j].name) {
                                const fTalent = data_talente_skills[j];
                                let lpstart = DisziplineTalents.lpGetStart(playercircle);
                                let talent: ICharTalent = {
                                    id: v4(),
                                    cid: cid,
                                    name: fTalent.name,
                                    discipline: disziplin,
                                    circle: playercircle,
                                    descr: 'Frei ' + playercircle + ' ',
                                    optional: false,
                                    karma: true,
                                    free: true,
                                    lpstart: lpstart,
                                    step: 1,
                                    stepfree: 1,
                                    strain: fTalent.strain,
                                    attribute: fTalent.attribute,
                                    action: fTalent.action,
                                    define:[]
                                }

                                talente.push(talent);
                            }
                        }
                    });
                }

                d.TuF.optionen.forEach((o) => {
                    if (playercircle >= o.f && playercircle <= o.t) {
                        o.talente.forEach(t => {
                            for (let j = 0; j < data_talente_skills.length; j++) {
                                let test = t.replace(/(.*) \[.*\]/, "$1")
                                if (test === data_talente_skills[j].name) {
                                    const fTalent = data_talente_skills[j];
                                    let lpstart = DisziplineTalents.lpGetStart(playercircle);
                                    let talent: ICharTalent = {
                                        id: v4(),
                                        cid: cid,
                                        name: fTalent.name,
                                        discipline: disziplin,
                                        circle: playercircle,
                                        descr: DisziplineTalents.talentOptionDifficulty(lpstart),
                                        optional: true,
                                        karma: false,
                                        free: false,
                                        lpstart: lpstart,
                                        step: 0,
                                        stepfree: 0,
                                        strain: fTalent.strain,
                                        attribute: fTalent.attribute,
                                        action: fTalent.action,
                                        define:[]
                                    }
                                    talente.push(talent);
                                }
                            }
                        });
                    }
                });
            }
        });
        return talente;
    },

    lpGetStart: function (playercircle: number) {
        let lpstart = 0;
        if (playercircle >= 1 && playercircle <= 4) lpstart = 100;
        if (playercircle >= 5 && playercircle <= 8) lpstart = 200;
        if (playercircle >= 9 && playercircle <= 12) lpstart = 300;
        if (playercircle >= 13 && playercircle <= 15) lpstart = 500;
        return lpstart;
    },

    talentOptionDifficulty: function (lps) {
        if (lps === 100) return 'Option Novize';
        if (lps === 200) return 'Option Geselle';
        if (lps === 300) return 'Option H�ter';
        if (lps === 500) return 'Option Meister';
        return '';
    }
}

export {DisziplineTalents}